/* eslint-disable no-nested-ternary */
import React, { useState, useContext } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { find } from 'lodash-es';
import { formatPostDate } from '@mummssoftware/utils/formatters';
import { PNCounterContext } from '@mummssoftware/global-context/PNCounter';
import { REFRESH_PN } from '@mummssoftware/global-context/PNCounter/constants';
import { Context } from '../../context';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import { UPDATE_PN_COUNT } from '../Context/constants';
import { MenuContentDiv } from '../../components/layout/WrapperDiv';
import { useStyles } from '../style/style';

type CheckBoxMenuProps = {
  note: mumms.progressNotebyEntity;
  text: string;
  entitykey: string;
  entitytypeshortname: mumms.PNEntityTypeShortname;
  med?: mumms.Medication;
  carePlan?: mumms.patientCarePlanProblem;
  carePlanFrequency?: mumms.patientCarePlanProblemFrequency;
  saveInitialNote: boolean | undefined;
};

const CheckBoxMenu = ({
  note,
  text,
  entitytypeshortname,
  entitykey,
  saveInitialNote,
}: CheckBoxMenuProps) => {
  const {
    updateProgressNoteEntity,
    getAllProgressNotes,
    agency,
    currentUser,
    patient,
  } = useContext(Context);
  const { dispatch } = useContext(ProgressNotesContext);
  const pnContext = useContext(PNCounterContext);

  const classes = useStyles();

  const foundItem =
    note.patientprogressnoteentitydto &&
    find(
      note.patientprogressnoteentitydto[entitytypeshortname],
      (x) => x.entitykey === entitykey,
    );
  const isChecked = !!foundItem;
  const [checked, setChecked] = useState(isChecked);

  // eslint-disable-next-line consistent-return
  const handleChange = (event: any) => {
    setChecked((event.target as any).checked);

    if (isChecked) {
      const progressNoteEntityData = {
        id: (foundItem as any).id,
        // entitykey,
        patientprogressnoteid: note.id,
        entitytypeshortname,
      };
      updateProgressNoteEntity(agency, progressNoteEntityData, 'DELETE').then(
        async () => {
          const payload = {
            refreshEntity: entitytypeshortname,
            refreshEntityKey: entitykey,
          };
          // if tagging an existing note update the count right away
          if (!saveInitialNote) {
            pnContext.dispatch &&
              pnContext.dispatch({
                type: REFRESH_PN,
                payload,
              });
            await getAllProgressNotes(patient.patientNumber, agency);
          }
          // if tagging a new note save the count in CONTEXT
          if (saveInitialNote) {
            dispatch({
              type: UPDATE_PN_COUNT,
              payload,
            });
          }
        },
      );
    } else {
      // save the entity name Med or CPP
      const progressNoteEntityData = {
        entitykey,
        entitytypeshortname,
        patientprogressnoteid: note.id,
        createdatetime: formatPostDate(new Date()),
        // need to be the user ID
        createpersonid: currentUser.userId,
        entityname: text,
      };
      // @note PN
      // if the Promise succeeds or fails the REFRESH_PN is activated , API call made with same result
      updateProgressNoteEntity(agency, progressNoteEntityData, 'POST').then(
        async () => {
          const payload = {
            refreshEntity: entitytypeshortname,
            refreshEntityKey: entitykey,
          };
          // if tagging an existing note update the count right away
          if (!saveInitialNote) {
            pnContext.dispatch &&
              pnContext.dispatch({
                type: REFRESH_PN,
                payload,
              });
            await getAllProgressNotes(patient.patientNumber, agency);
          }
          // if tagging a new note save the count in CONTEXT
          if (saveInitialNote) {
            dispatch({
              type: UPDATE_PN_COUNT,
              payload,
            });
          }
        },
      );
    }
  };

  return (
    <MenuContentDiv>
      <Checkbox
        checked={checked}
        onChange={handleChange}
        classes={{ root: classes.defaultColor }}
        inputProps={{ 'aria-label': 'controlled' }}
      />
      {text}
    </MenuContentDiv>
  );
};

export default CheckBoxMenu;
